import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from './services/i18n.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  title = 'Scam-Web';
  bodyDir;

  constructor(translate: TranslateService, private i18nService: I18nService) {
    translate.addLangs(['en', 'ar']);
    translate.setDefaultLang('ar');
    let lng = localStorage.getItem('lng');
    if(lng == null){
      lng ='ar';
    }
    translate.use(lng);
  }

  ngOnInit() {
    this.i18nService.getLang().subscribe((lng) => {
      if(lng == null){
        lng ='ar';
      }
      this.bodyDir = lng === "ar" ? 'rtl' : 'ltr';
    })
  }
}